import React from 'react';
import { withRouter, Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';
import Helmet from 'react-helmet';

import { urls } from '@/constants';

import ScrollToTop from '@/components/ScrollToTop';

import Loading from '@/components/Loading';
import If from '@/components/If';
import ConsumeRedirectRoute from '@/components/Navigation/ConsumeRedirectRoute';
import RedirectWithPersist from '@/components/Navigation/RedirectWithPersist';
import HomePage from '@/page/HomePage';
import Public from './page/Public';
import { SessionConsumer } from './components/Context/Session';
import { Toaster } from '@/components/ui/sonner';

import './styles/globals.css';

export interface Props extends RouteComponentProps {}

const App: React.FC<Props> = () => {
  return (
    <ScrollToTop>
      <SessionConsumer>
        {({ loading, error, session, me }) => (
          <React.Fragment>
            <Helmet defaultTitle="Kané Kitchen Admin" titleTemplate="%s - Kané Kitchen Admin" />

            <Loading visible={loading} />

            <If
              condition={!loading}
              then={() => (
                <If
                  condition={!error}
                  then={() => (
                    <If
                      condition={session && me}
                      then={() => (
                        <Switch>
                          <Route path={urls.home} component={HomePage} />
                          <ConsumeRedirectRoute render={() => <Redirect to={urls.home} />} />
                        </Switch>
                      )}
                      else={() => (
                        <Switch>
                          <Route path={urls.home} component={Public} />
                          <ConsumeRedirectRoute render={() => <RedirectWithPersist to={urls.signIn} />} />
                        </Switch>
                      )}
                    />
                  )}
                />
              )}
            />
            <Toaster richColors />
          </React.Fragment>
        )}
      </SessionConsumer>
    </ScrollToTop>
  );
};

export default withRouter(App);
